export enum AreaWidgetSizeConstraints {
  None,
  Square,
}
